import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { reduxForm, formPropTypes, Field } from 'redux-form';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
} from 'react-bootstrap';

import DistrictFilter from '../../fields/DistrictFilter';
import UserInput from '../../fields/UserInput';
import { DateField } from '../../fields/index';
import DepartmentFilter from '../../fields/DepartmentFilter';
import { createRenderer } from '../../reduxForm/utils';

import { setFilteringValues } from '../actions';

const propTypes = exact({
  setFilteringValuesAction: PropTypes.func.isRequired,
  initialValues: PropTypes.object,

  ...formPropTypes,
});

const FORM_NAME = 'PerDiemReportFilteringForm';


const RenderInput = createRenderer((input) => {
  return (
    <FormControl {...input} />
  );
});

const RenderDistrict = createRenderer((input, label, { district }) => {
  return (
    <DistrictFilter value={district} {...input} />
  );
});

const RenderDepartment = createRenderer((input, label, { department }) => {
  return (
    <DepartmentFilter value={department} {...input} />
  );
});

const RenderAllUsers = createRenderer((input, label) => {
  return (
    <UserInput allowClearInput={false} {...input} />
  );
});

const formatReduxStateDateValues = (stringDate) => {
  if (!stringDate) {
    return stringDate;
  }

  return new Date(stringDate).toISOString();
};

const PerDiemFilters = (props) => {
  const { handleSubmit, submitting, setFilteringValuesAction } = props;

  const formSubmit = (formValues) => {
    const payload = {};
    const {
      ticketJobNumber,
      district,
      department,
      user,
      requestedAt,
      requestedForDate,
      paymentDate,
    } = formValues;

    payload.ticketJobNumber = (ticketJobNumber) || '';
    payload.district = (district) || null;
    payload.department = (department) || null;
    payload.user = (user) || '';
    payload.requestedAt = formatReduxStateDateValues(requestedAt);
    payload.requestedForDate = formatReduxStateDateValues(requestedForDate);
    payload.paymentDate = formatReduxStateDateValues(paymentDate);
    payload.tableDataRequest = true;
    setFilteringValuesAction(payload);
  };

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit(formSubmit)}>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Field
                type="text"
                name="ticketJobNumber"
                label="Job or Ticket Number:"
                component={RenderInput}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Field
                name="district"
                type="select"
                label="District"
                format={null}
                component={RenderDistrict}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Field
                name="department"
                type="select"
                label="Department"
                format={null}
                component={RenderDepartment}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Field
                name="user"
                type="select"
                label="Employee:"
                format={null}
                component={RenderAllUsers}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroup>
              <DateField name="requestedAt" label="Requested At:" />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroup>
              <DateField name="requestedForDate" label="Requested For:" />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroup>
              <DateField name="paymentDate" label="Payment Date:" />
            </FormGroup>
          </Col>
        </Row>
        <Button
          bsStyle="primary"
          type="submit"
          disabled={submitting}
        >
          Submit
        </Button>
      </form>
    </React.Fragment>
  );
};


PerDiemFilters.propTypes = propTypes;
PerDiemFilters.defaultProps = {
  initialValues: {},
};

const withForm = reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
});

const mapDispatchToProps = {
  setFilteringValuesAction: setFilteringValues,
};

const withRedux = connect(null, mapDispatchToProps);

const enhance = compose(
  withRedux,
  withForm,
);

export default enhance(PerDiemFilters);
